import { render, staticRenderFns } from "./DataTwins.vue?vue&type=template&id=63a983fd&scoped=true"
import script from "./DataTwins.vue?vue&type=script&lang=js"
export * from "./DataTwins.vue?vue&type=script&lang=js"
import style0 from "./DataTwins.vue?vue&type=style&index=0&id=63a983fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a983fd",
  null
  
)

export default component.exports